import New from './PdcaCycleNew'
import Edit from './PdcaCycleEdit'
import Show from './PdcaCycleShow'

export default {
  New,
  Edit,
  Show,
}
